import Head from 'next/head'

import { BASE_URL } from '@configs/config'

interface AppLinkMetaProps {
  /** Custom path for the deeplink (e.g., 'story/123', 'top-view?categoryId=5') */
  path?: string
  /** Full URL for web fallback (optional, will use BASE_URL + path if not provided) */
  webUrl?: string
  /** Whether to include the base app meta tags (app_name, app_store_id, package) */
  includeBaseMeta?: boolean
}

export function AppLinkMeta({
  path = '',
  webUrl,
  includeBaseMeta = false,
}: AppLinkMetaProps) {
  const deeplinkUrl = path ? `mareads://${path}` : 'mareads://'
  const fallbackUrl = webUrl || (path ? `${BASE_URL}/${path}` : BASE_URL)

  return (
    <Head>
      {includeBaseMeta && (
        <>
          {/* Base App Links Meta Tags */}
          <meta property='al:ios:app_name' content='MaReads - มารี้ด' />
          <meta property='al:ios:app_store_id' content='1625633273' />
          <meta property='al:android:app_name' content='MaReads - มารี้ด' />
          <meta
            property='al:android:package'
            content='com.amarin.mareads.prd'
          />
          <meta property='fb:app_id' content='333909671742314' />
        </>
      )}

      {/* App Links Meta Tags */}
      <meta property='al:ios:url' content={deeplinkUrl} />
      <meta property='al:android:url' content={deeplinkUrl} />
      <meta property='al:web:url' content={fallbackUrl} />
    </Head>
  )
}
